<template>
    <component :is="type" class="mask-text-fade-in">
        <span v-html="text"></span>
    </component>
</template>

<script>
import Resize from '@/pure/Resize'

export default {
    props: {
        content: { type: String },
        onScroll: { type: Boolean, default: true },
        always: { type: Boolean, default: false },
        type: { type: String, default: 'span' }
    },

    data()
    {
        return {
            text: ''
        }
    },

    created()
    {
        const arr = this.content.split('\n').join('\\n ').split('\\n').join('\\n').split(' ')
        this.words = []
        arr.forEach(wordStr => {
            const breackLine = wordStr.substr(wordStr.length - 2, 2) === '\\n'
            const containerSpan = document.createElement('span')
            const sizeSpan = document.createElement('span')
            const wordSpan = document.createElement('span')
            wordSpan.classList.add('real')
            const subwordSpan = document.createElement('span')
            const textRaw = document.createTextNode(breackLine ? wordStr.substr(0, wordStr.length - 2) : wordStr)
            const textSize = document.createTextNode(breackLine ? wordStr.substr(0, wordStr.length - 2) : wordStr)
            sizeSpan.classList.add('size')

            sizeSpan.appendChild(textSize)
            subwordSpan.appendChild(textRaw)
            wordSpan.appendChild(subwordSpan)
            containerSpan.appendChild(wordSpan)
            containerSpan.appendChild(sizeSpan)

            this.words.push({
                el: containerSpan,
                currentClass: '',
                forceEndLine: breackLine
            })
        })
    },

    mounted()
    {
        this.words.forEach(word => {
            const after = word.forceEndLine ? document.createElement('br') : document.createTextNode(' ')
            this.$el.appendChild(word.el)
            this.$el.appendChild(after)
        })

        // Fix bad size on first words positions check, sorry :‘(
        // setTimeout(this.start, 500)
        this.$nextTick(this.start)

        this.resize = new Resize()
        this.resize.addOnResized(this.setClass)
    },

    activated()
    {
        this.$nextTick(this.start)
    },

    destroyed()
    {
        this.resize.removeOnResized(this.setClass)
        if (this._observer) {
            this._observer.unobserve(this.$el)
        }
    },

    deactivated()
    {

    },

    methods:
    {
        start() {
            this.setClass()
            if (!this.setClass()) {
                return requestAnimationFrame(this.start)
            }
            this.reset()

            if (!this.onScroll) {
                // Force refresh
                this.$el.offsetTop
                this.animate()
            } else {
                const options = {
                    rootMargin: '0px',
                    threshold: [0, 0.5]
                }

                this._observer = new IntersectionObserver(this.inOutScreen, options)
                this._observer.observe(this.$el)
            }
        },

        inOutScreen(entries) {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0.5) {
                    this.animate()
                } else if (this.always) {
                    this.reset()
                }
            })
        },

        setClass() {
            let error = false

            // Check if words moved
            let moved = 0
            let y = -1
            let line = 0
            this.words.forEach(word => {
                const el = word.el
                const currentY = el.offsetTop
                if (currentY < 0) {
                    error = true
                }
                if (currentY > y) {
                    y = currentY
                    line++
                }
                const className = 'line-' + line
                if (word.currentClass !== className) {
                    moved = true
                }
            })
            if (error) {
                return false
            }

            // Else update class
            y = -1
            line = 0
            const lastWords = [this.words.length - 1]
            this.words.forEach((word, index) => {
                const el = word.el
                const currentY = el.offsetTop
                if (currentY > y) {
                    y = currentY
                    line++

                    if (index > 0) {
                        lastWords.push(index - 1)
                    }
                }

                const className = 'line-' + line
                if (className !== word.currentClass) {
                    if (word.currentClass !== '') {
                        el.classList.remove(word.currentClass)
                    }
                    el.classList.add(className)
                    word.currentClass = className
                }

                // If there is no movement, don't remove class
                if (moved) {
                    el.classList.remove('is-last')
                }
            })

            // If there is no movement, don't set class
            if (moved) {
                for (let i = 0; i < lastWords.length; i++) {
                    const wordIndex = lastWords[i]
                    const el = this.words[wordIndex].el
                    el.classList.add('is-last')
                }
            }

            return true
        },

        reset() {
            this.words.forEach(word => {
                word.el.classList.add('is-reset')
            })
        },

        animate() {
            this.words.forEach(word => {
                word.el.classList.remove('is-reset')
            })
        }
    }
}
</script>

<style lang="sass" scoped>
.mask-text-fade-in
    @for $index from 1 through 10
        /deep/ .line-#{ $index }
            display: inline-block
            position: relative
            .size
                visibility: hidden
            .real
                position: absolute
                // top: -0.2em
                height: calc(100% + 0.4em)
                left: 0
                display: inline-block
                transition: transform .875s (0.0625s * $index) ease
                overflow: hidden
                &>span
                    margin-top: 0.2em
                    display: inline-block
                    position: relative
                    transition: transform .875s (0.0625s * $index) ease
        /deep/ .is-reset
            .real
                transform: translateY(120%)
                &>span
                    transform: translateY(-120%)
</style>
